import { Box } from '@mui/material';
import { ContentCard } from 'components/Card';
import { Text } from 'components/Text';
import { useCardHandlers } from '../hooks';
import { ClassicCardProps } from '../types';
import { DismissButton } from './DismissButon';

export const ClassicCard = ({
  card,
  onCardClick,
  onCardDismiss
}: ClassicCardProps) => {
  const { url, title, imageUrl, description, dismissible } = card;
  const { handleCardClick, handleDismiss } = useCardHandlers({
    card,
    onCardClick,
    onCardDismiss
  });

  return (
    <ContentCard
      sx={{
        cursor: url ? 'pointer' : 'default',
        position: 'relative',
        p: 3
      }}
    >
      {dismissible && <DismissButton onClick={handleDismiss} />}
      <Box onClick={handleCardClick} sx={dismissible ? { mr: 1 } : {}}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between'
          }}
        >
          {title && (
            <Text variant="h5" sx={{ mb: 1 }}>
              {title}
            </Text>
          )}
          {imageUrl && (
            <Box
              component="img"
              src={imageUrl}
              alt={imageUrl ?? 'Content card image'}
              sx={{
                width: '48px',
                height: '48px',
                borderRadius: 1,
                mb: 1
              }}
            />
          )}
        </Box>
        {description && (
          <Text variant="body2" color="text.secondary">
            {description}
          </Text>
        )}
      </Box>
    </ContentCard>
  );
};
